import TranslationDisplay from './component'

export default TranslationDisplay
